(function () {
  if (window.__alankiCartSyncInit) return;
  window.__alankiCartSyncInit = true;

  const CART_ENDPOINTS = ['/cart/add.js', '/cart/change.js', '/cart/update.js'];

  function syncCartCount() {
    fetch('/cart.js')
      .then(function (res) {
        if (!res.ok) throw new Error('cart.js fetch failed: ' + res.status);
        return res.json();
      })
      .then(function (cart) {
        var itemCount = cart.item_count || 0;
        var resolvedPayload = {
          cart: { totalQuantity: itemCount },
          detail: { itemCount: itemCount },
        };

        // Dispatch the event CartIcon is already listening for
        ['cartLinesUpdate', 'shopify:cart:lines:update'].forEach(function (name) {
          var evt = new CustomEvent(name, { bubbles: true, detail: resolvedPayload });
          evt.promise = Promise.resolve(resolvedPayload);
          document.dispatchEvent(evt);
        });
      })
      .catch(function (err) {
        console.warn('[alanki-cart-sync] Could not sync cart count:', err);
      });
  }

  function isCartEndpoint(url) {
    if (!url) return false;
    var str = String(url);
    return CART_ENDPOINTS.some(function (ep) { return str.includes(ep); });
  }

  // Intercept fetch
  var _fetch = window.fetch;
  window.fetch = function (input) {
    var url = (input instanceof Request) ? input.url : input;
    var promise = _fetch.apply(this, arguments);
    if (isCartEndpoint(url)) {
      promise.then(function (res) { if (res.ok) syncCartCount(); }).catch(function () {});
    }
    return promise;
  };

  // Intercept XMLHttpRequest
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._alankiUrl = url;
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (isCartEndpoint(this._alankiUrl)) {
      var xhr = this;
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) syncCartCount();
      });
    }
    return _send.apply(this, arguments);
  };

  // Also catch any custom events the theme may dispatch
  ['cart:updated', 'cart:refresh', 'product:added'].forEach(function (name) {
    document.addEventListener(name, syncCartCount);
  });

  // Sync once on load
  syncCartCount();
})();
